import React from 'react'
import FilePreview from '../FilePreview'
import UploadButton from './UploadButton'
import { useTranslation } from '../../../../lib/i18n'

const FileUpload = ({
  getValues,
  file,
  handleSetFile,
  setFile,
  selectImage,
}) => {
  const { t } = useTranslation()
  const isFileUploadEnabled = getValues('isFile')

  return (
    <div className="space-y-4 mt-4">
      <div className="flex flex-col sm:flex-row gap-2">
        <UploadButton
          htmlFor="upload-file-button"
          label={t('common.addYourFile')}
          iconName="upload"
          onChange={handleSetFile}
          disabled={!isFileUploadEnabled}
        />
        <UploadButton
          htmlFor="upload-other-image-button"
          label={t('common.addYourImage')}
          iconName="image"
          onChange={selectImage}
          accept="image/*"
        />
      </div>

      {file && (
        <FilePreview
          preview={file.preview}
          filename={file.raw?.name ?? t('common.fileAttachment')}
          type="File"
          onClick={() => setFile(null)}
        />
      )}
    </div>
  )
}

export default FileUpload
